import { Component } from '@angular/core';

@Component({
    selector: 'chassis-auth-login-page',
    templateUrl: './login.page.html',
    styleUrls: [ './login.page.scss' ],
})
export class LoginPage {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/pages/login/login.page.ts